import { Modifier, CartItem } from "@/components/cartDrawer/cartDrawer";

export const addToCart = (item: {
  id: string;
  name: string;
  price: number;
  quantity: number;
  modifiers: Modifier[];
  specialInstructions: string;
  subtotal: number;
  total: number;
  cartId: string;
}) => {
  const cartItem: CartItem = {
    key: item.cartId,
    value: item,
  };
  const cart = JSON.parse(global?.window?.localStorage.getItem("cart") || "[]");
  cart.push(cartItem);
  global?.window?.localStorage.setItem("cart", JSON.stringify(cart));
};

export const getCartItems = (): CartItem[] => {
  return JSON.parse(global?.window?.localStorage.getItem("cart") || "[]");
};

export const clearCart = () => {
  global?.window?.localStorage.removeItem("cart");
};

export const clearServiceCart = () => {
  global?.window?.localStorage.removeItem("serviceCart");
};
